import React from 'react';
import { Input, Form } from 'antd';
import { injectIntl } from 'react-intl';
import { validateBooleanString } from '../../Utils/FormValidators';
import EducationContext from './EducationContext';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

const { TextArea } = Input;

const { Item } = Form;
function School(props) {
  const { initialValue, isUniversityMasked,intl } = props;
  const { form } = React.useContext(EducationContext);
  return (
    <Item colon={false}>
      {form.getFieldDecorator('School', {
        initialValue,
        rules: [
          {
            validator: (rule, booleanString, callback) => validateBooleanString(rule, booleanString, callback, form),
          },
        ],
      })(
        <TextArea
          style={{ overflow: 'hidden' }}
          placeholder={intl.formatMessage({ ...message.harvardORStanfordUniversityLabel })}
          disabled={isUniversityMasked}

        />
      )}
    </Item>
  );
}

export default injectIntl(Form.create()(School));
export { School as SchoolWithoutInjectIntl };
